import { createStyles } from 'antd-style'

export const useStyle = createStyles({
  cardMetaAvatar: {
    overflow: 'unset'
  }
})
